<docs>
  Show this layer in center, with a dark gray background color
</docs>

<template>
  <section class="viewer-layer">
    <div
      :aria-label="$t('close')"
      class="viewer-layer-close-bg"
      @click="closeEvent"
    />
    <div
      class="viewer-layer-inner"
      :class="innerClassName"
    >
      <slot name="inner-extra" />
      <button
        :aria-label="$t('close')"
        class="viewer-layer-close"
        @click="closeEvent"
      >
        <icon class="icon-close-info-white" />
      </button>
      <slot />
    </div>
  </section>
</template>

<script>
import Icon from '../../Icon/index.vue'

export default {
  name: 'ViewerLayer',
  components: {
    Icon
  },
  props: {
    closeEvent: {
      type: Function,
      default () {
        return () => {}
      }
    },
    innerClassName: {
      type: String,
      default () {
        return ''
      }
    }
  },

  mounted () {
    window.addEventListener('keydown', this.viewerLayerKeydown)
  },

  beforeDestroy () {
    window.removeEventListener('keydown', this.viewerLayerKeydown)
  },

  methods: {
    viewerLayerKeydown (e) {
      if (e.keyCode === 27) { // 27 = esc
        this.closeEvent()
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'
@import '~css/common/extends'

$tabs-text-lh = 20px
$tabs-text-pd = 7px
$tabs-height = $tabs-text-lh + $tabs-text-pd * 2

.viewer-layer {
  @extend .absolute-full
  @extend .flex-center
  z-index: $viewer-layer-m-z
  color: $white
}

.viewer-layer-inner {
  @extend .full
  @extend .overflow-auto
  position: relative
  padding: 20px
  max-height: 100%
  background-color: alpha($dark-gray, 90%)
  box-shadow: 0 1px 1px rgba(20, 20, 20, .6)
  pointer-events: auto
  &.no-close-btn {
    .viewer-layer-close {
      display: none
    }
  }
}

.viewer-layer-close {
  @extend .flex-center
  @extend .btn-no-default
  position: fixed
  right: $viewer-layer-viewer-layer-close
  top: 7px
  padding: 10px
  z-index: $viewer-layer-close-z

  .icon-close-info-white {
    $w = 20px
    $h = 20px
    bg-size($w, $h)
  }
}

.viewer-layer-second-inner {
  padding: 25px 0 0
}

.viewer-layer-third-inner {
  display: flex
  justify-content: center
  align-items: center
  padding: 0
  overflow: visible
}

.viewer-layer-tabs {
  @extend .flex-center
  position: relative
  overflow: hidden
  height: $tabs-height
}

.viewer-layer-container {
  position: relative
  height: 100%
  overflow: auto
  -webkit-overflow-scrolling: touch

  @extend .scrollbar-narrow;
  &::-webkit-scrollbar-thumb {
    visibility: hidden
  }

  &:hover {
    &::-webkit-scrollbar-thumb {
      visibility: visible
    }
  }
}

.viewer-layer-tabs:not([style*='display: none']) + .viewer-layer-container {
  height: calc(100% - 34px)
}

.viewer-layer-li {
  @extend .flex-center
  position: relative
  z-index: $viewer-layer-li-z
  min-width: 50%

  &::after {
    @extend .absolute-full-width
    content: ''
    bottom: 0
    height: 1px
    background-color: $light-gray-color
  }

  &:nth-child(n + 2) {
    &::before {
      content: ''
      position: absolute
      left: 0
      bottom: 5px
      height: $tabs-text-lh
      width: 1px
      background-color: alpha($white, 70%)
    }
  }
}

.viewer-layer-li-active {
  &::after {
    background-color: $pink-color
    height: 4px
  }
}

.viewer-layer-text {
  @extend .text-ellipsis
  @extend .btn-no-default
  @extend .text-with-gray-bg
  padding: $tabs-text-pd 0
  line-height: $tabs-text-lh
  position: relative
  text-align: center
  font-size: 14px
  width: 100%
}

.viewer-layer-close-bg {
  @extend .absolute-full
}

@media (min-width: $response) {
  .viewer-layer {
    z-index: $viewer-layer-z
  }

  .viewer-layer-close {
    position: absolute
  }

  .viewer-layer-inner {
    max-width: 760px
    max-height: 482px
    padding: 50px 30px 30px
    border-radius: 8px
    &.viewer-layer-enlarge {
      padding: 20px
      max-width: 1172px
      max-height: 672px
    }
  }

  .viewer-layer-second-inner {
    padding: 50px 30px 10px
  }

  .viewer-layer-third-inner {
    width: auto
    height: auto
    max-width: 100%
    max-height: 100%
  }
}
.fullscreen{
  max-width: 100vw !important
  max-height: 100vh !important
  border-radius: 0
  overflow: hidden
}
</style>

<style lang="stylus" rel="stylesheet/stylus">
@import '~css/addon/main'

.theme-rtl.theme-rtl-overlap {
  .viewer-layer-close {
    right: auto
    left: $viewer-layer-viewer-layer-close
  }
}
</style>
